import RobotConfig from '../views/robot/robotConfig';
import ChatLibrary from '../views/robot/chatLibrary';
import Main from '../views/main';
const RbotRouter = {
  path: '/robot-config',
  component: Main,
  title: '机器人管理',
  icon: 'el-icon-s-custom',
  meta: { keepAlive: true },
  children: [
    {
      path: '/robot-config',
      component: RobotConfig,
      name: 'robotConfig',
      title: '机器人配置',
      meta: { title: '机器人配置' ,keepAlive:true}
    },
    {
      path: '/chat-library',
      component: ChatLibrary,
      name: 'chatLibrary',
      title: '聊天内容',
      meta: { title: '聊天内容' ,keepAlive:true}
    }
  ]
};
export default RbotRouter;
